/**
 * Where the baked diffuse SH probe grid is (ENG-561).
 *
 * The server states it. This used to derive the URL from the splat URL by
 * replacing the filename with `baked/lightprobes.json`, which encoded the
 * asset-manager's storage layout in the client — and produced wrong paths for
 * every environment uploaded before the org migration, indistinguishable from an
 * unbaked one because both answer 404 (ENG-999).
 *
 * Returns null when the environment has no baked grid, which is an answer:
 * callers must skip rather than fetch a URL to find out.
 */
import { environmentFileUrl } from './environmentFiles.js'

export async function lightProbeGridUrl(splatUrl) {
  return environmentFileUrl(splatUrl, 'lightprobes')
}
